import React, { Component } from 'react';
import GoogleAd from '../../../components/google/GoogleAd'
import FacebookLikeShare    from './FacebookLikeShare'
import ComponentHasTranslations from '../../../utils/component_has_translations'

class Shares extends Component {
  share_group = (group, i) => {
    return (
      <div key={i}>
        <div className="section_box section_shares">

          <h2> { this.tr('share_box.list.header') } </h2>

          { group.
            filter( record => record ).
            map(
              (record, j) => (
                <div className='share' key={j}>
                  <div className="comment">
                    <i className="fa fa-comment"/>
                    {' '}
                    { record.comment }
                  </div>
                  <div className="meta">
                    <div className="where">
                      {record.city && `${record.city}, `}
                      { record.country} 
                    </div>
                    <div className="when">
                      <i className="fa fa-calendar"/> { record.when } ago
                    </div>
                  </div>
                </div>
              )
            )
          }
        </div>
        <GoogleAd/>
      </div>
    )
  }

  render = () => {
    return (
      <>
        <div id='shares' className='thin_box'>
          { this.props.shares.map( (group, i) => this.share_group(group, i)) }
        </div>
      </>
    )
  }
}

Object.assign(Shares.prototype, ComponentHasTranslations)
export default Shares
